import React from "react";
import "./WelcomePanel.css";

export default function WelcomePanel({ onStart }) {
  const actions = [
    {
      icon: "⚖️",
      title: "Legal Advice",
      description: "Explain my legal rights & liabilities",
      prompt: "Explain my legal rights regarding",
    },
    {
      icon: "📄",
      title: "Review Document",
      description: "Analyze contracts or agreements",
      prompt: "Review this legal document and highlight key clauses",
    },
    {
      icon: "🏛️",
      title: "Legal Procedure",
      description: "Understand court & filing steps",
      prompt: "Explain the legal procedure for",
    },
    {
      icon: "📨",
      title: "Draft Legal Notice",
      description: "Create official notices & drafts",
      prompt: "Draft a legal notice for",
    },
  ];

  return (
    <div className="welcome-container">

      <div className="welcome-header">
        <div className="welcome-icon">⚖️</div>

        <h1 className="welcome-title">
          Welcome to <span>IndLawAI</span>
        </h1>

        <p className="welcome-subtitle">
          Your AI-powered legal assistant for Indian Laws,
          Rights, Court Procedures and Legal Documents.
        </p>
      </div>

      <div className="welcome-grid">
        {actions.map((item, index) => (
          <button
            key={index}
            className="welcome-card"
            onClick={() => onStart(item.prompt)}
          >
            <div className="welcome-card-icon">
              {item.icon}
            </div>

            <div className="welcome-card-content">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </button>
        ))}
      </div>
      
      <div className="welcome-trust">
        <div>🇮🇳 Indian Laws</div>
        <div>⚖️ Legal Rights</div>
        <div>📄 Documents</div>
        <div>🏛️ Court Procedures</div>
      </div> 

    </div>
  );
}